// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"a715a0fe","447":"2879d780","967":"acd84439"}[chunkId] + ".chunk.js";
};